'use client';
import React from 'react';
import Image from 'next/image';


const Hero = () => {
  const handleScroll = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth',
    });
  };

  return (
    <section id="hero" className="relative w-full h-[92vh] md:h-screen text-white ">
      <div
        className="absolute inset-0 w-full h-full z-0"
        style={{
          backgroundImage: `url('/hero3.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
        }}
      />

      <div className="relative flex flex-col items-center justify-start pt-[6vh] md:pt-[8vh] pb-[6vh] md:pb-[8vh] text-center h-full">
        
        <h1 className="text-[60px] md:text-[150px] uppercase lett mb-26 md:mb-0 leading-[50px] md:leading-[120px]"
        >
          Peterborough<br />Site Updates
        </h1>

        <button
          onClick={handleScroll}
          aria-label="Scroll down"
          className="bg-transparent mt-10 border-none shadow-none hover:scale-110 transition transform cursor-pointer"
        >
          <Image src="/button.svg" alt="Scroll down" width={56} height={56} />
        </button>
      </div>
    </section>
  );
};

export default Hero;